import type {ReactElement} from 'react';
import Menu from '@components/Menu/Menu';
import {Outlet} from 'react-router-dom';
import {StateProvider as BalanceStateProvider} from '@context/balance';
import OnboardingPopup from '@components/OnboardingPopup/OnboardingPopup';
import TopupPopup from '@components/TopupPopup/TopupPopup';
import config from '@config/index';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';

export default function Root(): ReactElement {
    const query = useQueryWithAuth({
        queryKey: ['me'],
        queryFn: me,
        refetchOnWindowFocus: true,
    });

    return (
        <BalanceStateProvider>
            <Menu />
            <Outlet />
            <OnboardingPopup isActive={!query.data?.data.isOnboarded} />
            <TopupPopup
                isActive={
                    query.data ? query.data.data.pagesRemaining < config.topupPopupThreshold : false
                }
            />
        </BalanceStateProvider>
    );
}
